import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatDate } from "../../../libs/utils";
import { useTimezone } from "../../../contexts/TimezoneContext";

const TransactionTimeline = ({ timeline }) => {
  const { timezoneValue } = useTimezone();
  const headers = [
    "Stage",
    "Status",
    "Date and Time",
    "Platform Trxn_id",
    "Remark",
  ];

  if (!timeline.length) {
    return <></>;
  }

  return (
    <>
      <div className="lineBreak" />
      <div className="heading">
        <div>Funds timeline:</div>
        <div className="mt15">
          <Table sx={{ border: 0.5 }}>
            <TableHead>
              <TableRow>
                {headers.map((h) => (
                  <TableCell
                    sx={{
                      border: 0.5,
                      fontSize: "18px",
                      background: "#F1F2F4",
                    }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {timeline.map(
                ({
                  stageName,
                  status,
                  time,
                  platformTrxnId = "NA",
                  remark = "NA",
                }) => (
                  <TableRow key={stageName}>
                    <TableCell sx={{ border: 0.5 }}>{stageName}</TableCell>
                    <TableCell sx={{ border: 0.5 }}>{status}</TableCell>
                    <TableCell sx={{ border: 0.5 }}>
                      {formatDate(time, timezoneValue)}
                    </TableCell>
                    <TableCell sx={{ border: 0.5 }}>{platformTrxnId}</TableCell>
                    <TableCell sx={{ border: 0.5 }}>{remark}</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default TransactionTimeline;
